import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, GoogleAuthProvider } from 'firebase/auth';
import {
  connectFirestoreEmulator,
  initializeFirestore,
} from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { connectStorageEmulator, getStorage } from 'firebase/storage';
import { buildFirebaseConfig } from './firebaseConfig';

const firebaseConfig = buildFirebaseConfig(
  process.env,
  typeof window !== 'undefined' ? window.location.hostname : undefined,
);

const useEmulators =
  typeof window !== 'undefined' && window.location.hostname === 'localhost';

const FIRESTORE_DATABASE_ID = '(default)';

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = initializeFirestore(
  app,
  useEmulators ? { experimentalForceLongPolling: true } : {},
  FIRESTORE_DATABASE_ID,
);
export const functions = getFunctions(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

if (useEmulators) {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8090);
  connectFunctionsEmulator(functions, 'localhost', 5001);
  connectStorageEmulator(storage, 'localhost', 9199);
}
